import { ApplicationState } from '../../store/rootReducer';

export const getPersonalId = (state: ApplicationState): string => {
    return state.signIn.personalId;
};
